export const NOTIFICATION_DELIVERY_OPTIONS = ["Email", "Text Message"] as const;
